import { SectionLabel } from '@perch/ui';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const STEPS = [
  { title: 'Book your flight.', desc: 'Any airline, any route. Then forward your confirmation to Perch.' },
  { title: 'We watch the price.', desc: 'Automatic checks on your exact fare. Cash and award bookings.' },
  { title: 'Price drops, you save.', desc: 'We handle the rebook. Your airline issues a travel credit for the difference.' },
];

export function HowItWorksSection() {
  const section = useScrollReveal();

  return (
    <section id="how-it-works" className="relative py-24 px-4 sm:px-6 bg-white dark:bg-stone-900 scroll-mt-20">
      <div
        ref={section.ref}
        className={`max-w-2xl mx-auto transition-[opacity,transform] duration-500 ease-out ${section.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
      >
        <SectionLabel className="mb-10">How It Works</SectionLabel>

        <ol className="space-y-8">
          {STEPS.map((step, i) => (
            <li key={i}>
              <h3 className="text-xl font-serif text-stone-900 dark:text-stone-100">
                <span className="text-stone-300 dark:text-stone-600 mr-3">{i + 1}.</span>
                {step.title}
              </h3>
              <p className="text-stone-500 dark:text-stone-400 mt-1 ml-8 leading-relaxed">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
